import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=0bf97413&scoped=true&"
import script from "./PopUp.vue?vue&type=script&lang=js&"
export * from "./PopUp.vue?vue&type=script&lang=js&"
import style0 from "./PopUp.vue?vue&type=style&index=0&id=0bf97413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf97413",
  null
  
)

export default component.exports